export const getTeamGoalsReportColumns = ({ formatMoney, formatNumber }) => [
  {
    title: "Team",
    dataIndex: "teamName",
    key: "teamName",
    render: (value) => value || "--",
  },
  {
    title: "Leader",
    dataIndex: "leaderName",
    key: "leaderName",
    render: (value) => value || "--",
  },
  {
    title: "Deposits",
    dataIndex: "deposits",
    key: "deposits",
    render: (value) => formatMoney(value),
  },
  {
    title: "Withdrawals",
    dataIndex: "withdrawals",
    key: "withdrawals",
    render: (value) => formatMoney(value),
  },
  {
    title: "NMI",
    dataIndex: "nmi",
    key: "nmi",
    render: (value) => formatMoney(value),
  },
  {
    title: "FTD",
    dataIndex: "ftd",
    key: "ftd",
    render: (value) => formatNumber(value, 0),
  },
  {
    title: "Active Clients",
    dataIndex: "activeClients",
    key: "activeClients",
    render: (value) => formatNumber(value, 0),
  },
  {
    title: "Conv.",
    dataIndex: "conversionRatio",
    key: "conversionRatio",
    render: (value) => `${formatNumber(value)}%`,
  },
];
